import {RouteRecordRaw, RouterView} from "vue-router";
import LayoutView from "@/views/share/LayoutView.vue";
import HeaderView from "@/views/share/HeaderView.vue";
import ServiceSideView from "@/views/service/ServiceSideView.vue";

export default <Array<RouteRecordRaw>>[
    {
        path: '/service',
        name: '',
        meta: {auth: true},
        component: LayoutView,
        children: [
            {
                path: '',
                name: '',
                meta: {auth: true},
                components: {
                    default: RouterView,
                    header: HeaderView,
                    side: ServiceSideView,
                },
                children: [
                    {
                        path: '',
                        name: '',
                        meta: {auth: true},
                        component: () => import(/* webpackChunkName: "vip" */ './VIPPage.vue'),
                    },
                    {
                        path: 'theme',
                        name: '',
                        meta: {auth: true},
                        component: () => import(/* webpackChunkName: "theme" */ './ThemePage.vue'),
                    },
                    {
                        path: 'element',
                        name: '',
                        meta: {auth: true},
                        component: () => import(/* webpackChunkName: "element" */ './ElementPage.vue'),
                    },
                    {
                        path: 'production',
                        name: '',
                        meta: {auth: true},
                        component: () => import(/* webpackChunkName: "production" */ './ProductionPage.vue'),
                    },
                    {
                        path: 'teach',
                        name: '',
                        meta: {auth: true},
                        component: () => import(/* webpackChunkName: "teach" */ './TeachPage.vue'),
                    },
                    {
                        path: 'ad',
                        name: '',
                        meta: {auth: true},
                        component: () => import(/* webpackChunkName: "ad" */ './ADPage.vue'),
                    },
                ]
            }
        ]
    }
]
